import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, Suspense as _Suspense, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7bf9cd94"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "view",
  "data-view": ""
}
const _hoisted_2 = { class: "dashboard" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Não há nenhum comentário por aqui", -1))
const _hoisted_4 = {
  key: 5,
  class: "pills"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pills__title" }, "Fique por dentro", -1))
const _hoisted_6 = {
  key: 7,
  class: "new-courses"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ongoing-course__title" }, "Acabou de decolar! 🚀 ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ongoing-course__line" }, "lançamentos", -1))
const _hoisted_9 = {
  key: 8,
  class: "ongoing-course"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ongoing-course__title" }, "Continue de onde você parou!", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ongoing-course__line" }, "em andamento", -1))
const _hoisted_12 = {
  key: 9,
  class: "events"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "events__title" }, " Treinamentos ", -1))
const _hoisted_14 = { class: "courses-container" }
const _hoisted_15 = { class: "filter" }
const _hoisted_16 = { class: "card-schools custom-palette" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "center-content" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Não encontrado. ")
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "courses-list" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Não há nenhum treinamento por aqui ")
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "dashboard-fallback",
  style: {"display":"none"}
}, [
  /*#__PURE__*/_createElementVNode("h2", null, " Não há nenhum treinamento disponível no momento, em caso de dúvida entre em contato conosco pelo email: decola@lince.com.br. ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Comment = _resolveComponent("Comment")!
  const _component_content_fallback = _resolveComponent("content-fallback")!
  const _component_CommentModal = _resolveComponent("CommentModal")!
  const _component_IntroductoryContentModal = _resolveComponent("IntroductoryContentModal")!
  const _component_InfoIcon = _resolveComponent("InfoIcon")!
  const _component_InfoPanel = _resolveComponent("InfoPanel")!
  const _component_BackToTopButton = _resolveComponent("BackToTopButton")!
  const _component_steps = _resolveComponent("steps")!
  const _component_OnboardingModal = _resolveComponent("OnboardingModal")!
  const _component_PillModal = _resolveComponent("PillModal")!
  const _component_PillComponent = _resolveComponent("PillComponent")!
  const _component_PillLoader = _resolveComponent("PillLoader")!
  const _component_Slide = _resolveComponent("Slide")!
  const _component_Navigation = _resolveComponent("Navigation")!
  const _component_carousel = _resolveComponent("carousel")!
  const _component_MandatoryCourseTrack = _resolveComponent("MandatoryCourseTrack")!
  const _component_NewCourse = _resolveComponent("NewCourse")!
  const _component_OngoingCourse = _resolveComponent("OngoingCourse")!
  const _component_Event = _resolveComponent("Event")!
  const _component_InterestSection = _resolveComponent("InterestSection")!
  const _component_SelectBox = _resolveComponent("SelectBox")!
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_course = _resolveComponent("course")!
  const _component_PaginationDefault = _resolveComponent("PaginationDefault")!
  const _component_ContentFallback = _resolveComponent("ContentFallback")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      ($setup.isCommentsModalOpen)
        ? (_openBlock(), _createBlock(_component_CommentModal, {
            key: 0,
            onCloseCommentsModal: $setup.closeCommentsModal,
            title: $setup.commentModalTitle
          }, {
            default: _withCtx(() => [
              ($setup.comments.length)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.comments, (comment, index) => {
                    return (_openBlock(), _createBlock(_component_Comment, {
                      key: index,
                      "user-name": comment.userName,
                      comment: comment.message,
                      date: $setup.toLocaleDateTime(comment.createAt),
                      stars: comment.rating,
                      "user-image": comment.userImage,
                      "content-name": comment.contentName
                    }, null, 8, ["user-name", "comment", "date", "stars", "user-image", "content-name"]))
                  }), 128))
                : (_openBlock(), _createBlock(_component_content_fallback, { key: 1 }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          }, 8, ["onCloseCommentsModal", "title"]))
        : _createCommentVNode("", true),
      ($setup.openModalIntroductoryContent && $setup.introductoryContent)
        ? (_openBlock(), _createBlock(_component_IntroductoryContentModal, {
            key: 1,
            onClose: $setup.closeModalIntroductoryContent,
            "introductory-content": $setup.introductoryContent
          }, null, 8, ["onClose", "introductory-content"]))
        : _createCommentVNode("", true),
      ($setup.informationsExist)
        ? (_openBlock(), _createBlock(_component_InfoIcon, {
            key: 2,
            onToggleInfo: $setup.toggleInfoPanel
          }, null, 8, ["onToggleInfo"]))
        : _createCommentVNode("", true),
      _createVNode(_component_InfoPanel, {
        isVisible: $setup.isInfoPanelVisible,
        onToggleInfo: $setup.toggleInfoPanel,
        fetchInformations: $setup.fetchInformations
      }, null, 8, ["isVisible", "onToggleInfo", "fetchInformations"]),
      _createVNode(_component_BackToTopButton, { "is-info-panel-open": $setup.isInfoPanelVisible }, null, 8, ["is-info-panel-open"]),
      ($setup.showOnboarding())
        ? (_openBlock(), _createBlock(_component_OnboardingModal, {
            key: 3,
            onClose: $setup.closeOnBoarding,
            onFinishOnBoarding: $setup.finishOnBoarding,
            onPreviousStep: $setup.previousStep,
            onNextStep: $setup.nextStep,
            onStepChanged: _cache[2] || (_cache[2] = ($event: any) => ($setup.setStep($event))),
            class: "onboarding",
            steps: $setup.steps,
            "current-step": $setup.currentStep
          }, {
            default: _withCtx(() => [
              ($setup.user.name)
                ? (_openBlock(), _createBlock(_component_steps, {
                    key: 0,
                    user: $setup.user,
                    "onUpdate:user": _cache[0] || (_cache[0] = ($event: any) => (($setup.user) = $event)),
                    "onUpdate:userInterests": _cache[1] || (_cache[1] = ($event: any) => ($setup.updateUserInterests($event))),
                    "current-step": $setup.currentStep,
                    interests: $setup.interests,
                    messages: $setup.messages
                  }, null, 8, ["user", "current-step", "interests", "messages"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["onClose", "onFinishOnBoarding", "onPreviousStep", "onNextStep", "steps", "current-step"]))
        : _createCommentVNode("", true),
      ($setup.openPill && $setup.completedPills.length)
        ? (_openBlock(), _createBlock(_component_PillModal, {
            key: 4,
            pills: $setup.completedPills || [],
            onClose: $setup.closePill,
            class: "stories",
            "start-pill": $setup.startPill
          }, null, 8, ["pills", "onClose", "start-pill"]))
        : _createCommentVNode("", true),
      ($setup.incompletePills.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_carousel, {
              class: _normalizeClass([
            'carousel-pills',
            {
              center: $setup.isPillsCentered
            }
          ]),
              settings: $setup.pillSettings,
              breakpoints: $setup.pillBreakpoints,
              modelValue: $setup.pillInFocusIndex,
              "onUpdate:modelValue": [
                _cache[3] || (_cache[3] = ($event: any) => (($setup.pillInFocusIndex) = $event)),
                _cache[4] || (_cache[4] = ($event: any) => ($setup.handleSlidePill($options.pill.id)))
              ]
            }, {
              addons: _withCtx(() => [
                _createVNode(_component_Navigation)
              ]),
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.incompletePills, (pill, index) => {
                  return (_openBlock(), _createBlock(_component_Slide, {
                    class: "pills__slider",
                    key: 'pills' + index
                  }, {
                    default: _withCtx(() => [
                      ($setup.showPills)
                        ? (_openBlock(), _createBlock(_Suspense, { key: 0 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_PillComponent, {
                                onClickCapture: ($event: any) => ($setup.playPill(index)),
                                title: pill.title,
                                watched: pill.isWatched,
                                background: pill.imageURL
                              }, null, 8, ["onClickCapture", "title", "watched", "background"])
                            ]),
                            fallback: _withCtx(() => [
                              _createVNode(_component_PillLoader)
                            ]),
                            _: 2
                          }, 1024))
                        : (_openBlock(), _createBlock(_component_PillLoader, { key: 1 }))
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }, 8, ["class", "settings", "breakpoints", "modelValue"])
          ]))
        : _createCommentVNode("", true),
      ($setup.mandatoryCourseTrack?.length)
        ? (_openBlock(), _createBlock(_component_MandatoryCourseTrack, { key: 6 }))
        : _createCommentVNode("", true),
      false
        ? (_openBlock(), _createElementBlock("section", _hoisted_6, [
            _hoisted_7,
            _hoisted_8,
            _createVNode(_component_carousel, {
              settings: $setup.newCourseSettings,
              breakpoints: $setup.newCourseBreakpoints
            }, {
              addons: _withCtx(() => [
                _createVNode(_component_Navigation)
              ]),
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.newsCourses, (course, index) => {
                  return (_openBlock(), _createBlock(_component_Slide, {
                    key: 'new-course' + index
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_NewCourse, { course: course }, null, 8, ["course"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }, 8, ["settings", "breakpoints"])
          ]))
        : _createCommentVNode("", true),
      ($setup.coursesInProgress.length)
        ? (_openBlock(), _createElementBlock("section", _hoisted_9, [
            _hoisted_10,
            _hoisted_11,
            _createVNode(_component_carousel, {
              settings: $setup.ongoingCourseSettings,
              breakpoints: $setup.ongoingCourseBreakpoints,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (
            $setup.handleSlideCoursesInProgress($setup.coursesInProgress.id)
          ))
            }, {
              addons: _withCtx(() => [
                _createVNode(_component_Navigation)
              ]),
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.coursesInProgress, (course, index) => {
                  return (_openBlock(), _createBlock(_component_Slide, {
                    key: 'ongoingCourse' + index
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_OngoingCourse, { course: course }, null, 8, ["course"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }, 8, ["settings", "breakpoints"])
          ]))
        : _createCommentVNode("", true),
      ($setup.eventCourses.length)
        ? (_openBlock(), _createElementBlock("section", _hoisted_12, [
            _hoisted_13,
            _createVNode(_component_carousel, {
              class: "carousel-events",
              settings: $setup.eventsSettings,
              breakpoints: $setup.eventsBreakpoints
            }, {
              addons: _withCtx(() => [
                _createVNode(_component_Navigation)
              ]),
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.eventCourses, (event, index) => {
                  return (_openBlock(), _createBlock(_component_Slide, {
                    key: index,
                    class: "card-align"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Event, {
                        event: event,
                        onOpenIntroductoryContent: ($event: any) => (
                $setup.openIntroductoryContent(event.introductoryContent)
              )
                      }, null, 8, ["event", "onOpenIntroductoryContent"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }, 8, ["settings", "breakpoints"])
          ]))
        : _createCommentVNode("", true),
      ($setup.userInterests !== null)
        ? (_openBlock(), _createBlock(_component_InterestSection, { key: 10 }))
        : _createCommentVNode("", true),
      _createElementVNode("main", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            ($setup.isSelectBoxVisible)
              ? (_openBlock(), _createBlock(_component_SelectBox, {
                  key: 0,
                  "entity-name": "courseTracks",
                  "option-label-attribute": "name",
                  options: $setup.schools,
                  "model-value": $setup.selectedSchoolBox,
                  "onUpdate:model-value": _cache[6] || (_cache[6] = ($event: any) => (($setup.selectedSchoolBox) = $event)),
                  label: "escola"
                }, null, 8, ["options", "model-value"]))
              : _createCommentVNode("", true),
            (!$setup.isSelectBoxVisible)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($setup.schools, (school, index) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: index,
                    class: _normalizeClass(['school', { active: $setup.isSchoolActive(school.id) }]),
                    onClick: ($event: any) => ($setup.filterBySchool(school.id))
                  }, _toDisplayString(school.name), 11, _hoisted_17))
                }), 128))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_18, [
            ($setup.courseTracks.length > 0)
              ? (_openBlock(), _createBlock(_component_VueMultiselect, {
                  key: 0,
                  options: $setup.courseTracks,
                  label: "title",
                  "track-by": "title",
                  multiple: true,
                  placeholder: "Pesquisar trilha",
                  modelValue: $setup.selectedCourseTracks,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.selectedCourseTracks) = $event)),
                  onSearchChange: $setup.selectedCourseTracks,
                  selectedLabel: "Selecionado",
                  deselectLabel: "Remover",
                  selectLabel: "Selecionar trilha"
                }, {
                  noResult: _withCtx(() => [
                    _hoisted_19
                  ]),
                  _: 1
                }, 8, ["options", "modelValue", "onSearchChange"]))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("input", {
              type: "search",
              class: "header__search",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.searchTraining) = $event)),
              placeholder: "O que você quer aprender?",
              "data-search": ""
            }, null, 512), [
              [_vModelText, $setup.searchTraining]
            ])
          ])
        ]),
        ($setup.courses.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.courses, (course, index) => {
                  return (_openBlock(), _createBlock(_component_course, {
                    course: course,
                    key: index,
                    blocked: course.isBlocked,
                    class: "main-courses",
                    onOpenIntroductoryContent: ($event: any) => (
                $setup.openIntroductoryContent(course.introductoryContent)
              ),
                    onLoadCourseCommentsModal: ($event: any) => ($setup.loadCourseCommentsModal(course)),
                    onOpenCourse: ($event: any) => (
                _ctx.$router.push({
                  name: 'course',
                  params: { course_id: course.id }
                })
              )
                  }, null, 8, ["course", "blocked", "onOpenIntroductoryContent", "onLoadCourseCommentsModal", "onOpenCourse"]))
                }), 128))
              ]),
              ($setup.coursesPages)
                ? (_openBlock(), _createBlock(_component_PaginationDefault, {
                    key: 0,
                    "qt-pages": $setup.coursesPages,
                    currentPage: Number(_ctx.$route.query.page) || 1,
                    onChangePage: _cache[9] || (_cache[9] = ($event: any) => ($setup.updateQuery(_ctx.$router, 'page', $event)))
                  }, null, 8, ["qt-pages", "currentPage"]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createBlock(_component_ContentFallback, { key: 1 }, {
              default: _withCtx(() => [
                _hoisted_22
              ]),
              _: 1
            }))
      ]),
      _hoisted_23
    ])
  ]))
}